module.exports = __webpack_public_path__ + "static/scale-model-of-signal-hill-safaris-in-san-francisco-california-41027c132101ce6b31174eef9440e46c.png";